import { Injectable, inject } from '@angular/core';
import { SnackbarService } from './snackbar.service';

@Injectable({
    providedIn: 'root'
})
export class CustomToastrService {
    private _snackbar = inject(SnackbarService);

    private formatMessage(message: string, title?: string): string {
        return title ? `${title}: ${message}` : message;
    }

    success(message: string, title?: string, override?: any) {
        this._snackbar.successSnackbar(this.formatMessage(message, title));
    }

    error(message: string, title?: string, override?: any) {
        this._snackbar.errorSnackbar(this.formatMessage(message, title));
    }

    warning(message: string, title?: string, override?: any) {
        this._snackbar.warnSnackbar(this.formatMessage(message, title));
    }

    info(message: string, title?: string, override?: any) {
        this._snackbar.infoSnackbar(this.formatMessage(message, title));
    }

    show(message: string, title?: string, override?: any, type?: string) {
        this._snackbar.infoSnackbar(this.formatMessage(message, title));
    }
}
